import aLteDescriptionBlock from './aLteDescriptionBlock.vue'

const components = {
  aLteDescriptionBlock
}

const VuePlugin = {
  install(Vue) {
    Object.keys(components).forEach((component) => {
      Vue.component(component, components[component])
    })
  }
}

export default VuePlugin
